import {InfoIconMessage, Layout, Text} from '@eitje/web_components'
import {prettyPrintArray} from '@eitje/utils'

export const AdminsCell = ({row, total}) => {
	const admins = row.original.admins || row.original.environments._map('admins').flat().uniq('id')
	const adminNames = admins._map('full_name')
	const adminInfo = admins.map(admin => `${admin.full_name}\n${admin.email}`).join('\n\n')
	return (
		<Layout style={{display: 'inline-flex'}} width="full">
			<Text truncate>{prettyPrintArray({array: adminNames, quotes: false, joinWord: '&', sort: true})}</Text>
			<InfoIconMessage title="common.admins" icon="question-mark" t="common.admins" body={adminInfo} />
			<Text>{total}</Text>
		</Layout>
	)
}
